import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-coredatabaseget-component', (editor, opts) => {
  const config = {
    blocks: [
      'CoreDatabaseGet',
    ],
    name: 'coredbComponent',
    stylePrefix: 'gjs-',
    labelComponent: 'Lectura de Datos',
    defText: 'Sample',
    category: 'Base de Datos',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
